/**
 * Masters Vuex Store Module
 * State management for the master tag import feature.
 */

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const MASTERS = {
  namespaced: true,

  state: {
    // === Batch Management ===
    batches: [],
    batchesTotal: 0,
    currentBatch: null,
    currentBatchTags: [],
    currentBatchTagsTotal: 0,

    // === Loading States ===
    loading: false,
    importing: false,
    deleting: false,

    // === Error State ===
    error: null,

    // === Upload Wizard State ===
    wizardOpen: false,
    wizardStep: 1, // 1: Config, 2: Upload, 3: Mapping, 4: Preview

    // Step 1: Configuration
    selectedTagType: 'Equipment', // 'Equipment' | 'Pipeline' | 'Structural' - Default to Equipment
    selectedScopeType: 'Facility', // 'Facility' | 'Group'
    selectedTargetId: null, // facilityId or groupId
    batchName: '',

    // Step 2: File Upload
    parsedData: [], // Parsed Excel rows
    excelColumns: [], // Column headers from Excel
    sourceFileName: '',

    // Step 3: Column Mapping
    columnMappings: {}, // { systemField: excelColumn }
    customAttributeSelections: {}, // { excelColumn: boolean }
    customDisplayNames: {}, // { excelColumn: displayName }
    customDataTypes: {}, // { excelColumn: dataType }

    // Step 4: Preview & Duplicate Handling
    duplicateCheckResult: null,
    duplicateHandling: 'Skip', // 'Skip' | 'Merge'

    // === Import Result ===
    importResult: null,

    // === Import Progress (SSE streaming) ===
    importProgress: null, // { processed, total, successCount, skippedCount, mergedCount, failedCount }

    // === Background Job Tracking ===
    pendingImportJob: null,

    // === Pagination ===
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: ['createDate'],
      sortDesc: [true],
    },

    // === Tags Dialog ===
    tagsDialogOpen: false,

    // === Schema Cache (for custom attributes) ===
    schemasCache: {}, // { [batchId]: RegisterColumnDefinition[] }
    schemasCacheLoaded: false,

    // === API Data Source State ===
    apiDataSources: [],
    apiDataSourcesTotal: 0,
    apiDataSourceLoading: false,

    // === Execution History ===
    executionHistory: [],
    executionHistoryTotal: 0,
    executionHistoryLoading: false,
  },

  getters,
  mutations,
  actions,
};

export default MASTERS;
